module.exports = __webpack_public_path__ + "img/Hardtop.cbccfc94.jpg";